var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'pt-0': _vm.$route.meta.titleType == 'noTitle' },attrs:{"id":"app","safe-area-inset-top":""}},[_c('KeepAlive',[(_vm.$route.meta.keepAlive == true)?_c('router-view',{key:_vm.$route.path}):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view',{key:_vm.$route.path}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }